<template>
      <td :colspan="colspan">
        <div class="row mr-2 ml-2">
          <div class="col-lg-4 col-md-4 col-12">
            <dl class="row">
              <dt class="col-sm-5">Updated</dt>
              <dd class="col-sm-7 mb-0">
                <span v-if="row.updated_at != null">{{
                  row.updated_at | dateConvertDDMMYYYYTime
                }}</span>
                <span v-else></span>
              </dd>
              <dt class="col-sm-5">Add by</dt>
              <dd class="col-sm-7 mb-0">{{ row.createdBy }}</dd>
              <dt class="col-sm-5">Referred by BDM</dt>
              <dd class="col-sm-7 mb-0">{{ row.bdmFirstName }}</dd>
            </dl>
          </div>

          <div class="col-lg-4 col-md-4 col-12">
            <p class="fw-600 fs-100 text-info mb-0">
              Bank Information
            </p>
            <dl class="row">
              <dt class="col-sm-5">BSB</dt>
              <dd class="col-sm-7 mb-0">
                {{ row.bsb }}
              </dd>
              <dt class="col-sm-5">Account name</dt>
              <dd class="col-sm-7 mb-0">{{ row.accountName }}</dd>
              <dt class="col-sm-5">Account number</dt>
              <dd class="col-sm-7 mb-0">{{ row.accountNumber }}</dd>
              <dt class="col-sm-5">Account secondary email</dt>
              <dd class="col-sm-7 mb-0">
                {{ row.accountSecondEmail }}
              </dd>
            </dl>
          </div>
          <div class="col-lg-4 col-md-4 col-12">
            <p class="fw-600 fs-100 text-info mb-0">Other</p>
            <dl class="row">
              <dt class="col-sm-5">ABN</dt>
              <dd class="col-sm-7 mb-0">{{ row.abn }}</dd>
            </dl>
          </div>
        </div>
      </td>
</template>

  <script>
export default {
  name: 'dealerListExpand',
  props:['colspan', 'row']

}
</script>
